export default __webpack_public_path__ + "static/media/jobs-search.d9919424.png";